<template>
    <IndexModelLayout
        :createRoute="$route('admin::companies.create')"
        :modelNamePlural="__('admin::companies.companies')"
    >

        <Table
            :headings="[
                __('admin::labels.name'),
            ]"
            :paginator="paginator"
            @filter="submit"
        >

            <template #filters>
                <Input :placeholder="__('admin::forms.search')" v-model="filter.search" variant="filter" />
            </template>

            <template #results>
                <tr v-for="company in paginator.data" :key="company.id">
                    <td>{{ company.name }}</td>
                    <td>
                        <TableButton
                            variant="edit"
                            :href="$route('admin::companies.edit', { company: company.id })"
                        />
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::companies.destroy', { company: company.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::companies.company') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </IndexModelLayout>
</template>

<script>
    export default {
        props: {
            paginator: Object,
            request: Object,
        },
        data() {
            return {
                filter: this.$inertia.form({
                    search: this.request.search,
                }),
                deleting: null,
            }
        },
        methods: {
            submit() {
                this.filter.get(this.$route('admin::companies.index'));
            },
        },
    }
</script>
